import api from 'service/api'

const dponetAPI = api.create('supplierPortal')

const create = async ({
  companySupplierQuestionnaireId,
  quizQuestionTemplateId,
  params,
}) => {
  return await dponetAPI.postForm(
    `/company_supplier_questionnaires/${companySupplierQuestionnaireId}/quiz_question_templates/${quizQuestionTemplateId}/questionnaire_alternative_answers`,
    { questionnaireAlternativeAnswer: params },
  )
}

const update = async ({
  companySupplierQuestionnaireId,
  quizQuestionTemplateId,
  id = '',
  params,
}) => {
  return await dponetAPI.putForm(
    `/company_supplier_questionnaires/${companySupplierQuestionnaireId}/quiz_question_templates/${quizQuestionTemplateId}/questionnaire_alternative_answers/${id}`,
    { questionnaireAlternativeAnswer: params },
  )
}

export default { create, update }
